<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Overlay loader -->
      <overlay-loader v-if="isLoading.length > 0"></overlay-loader>         
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container">
            <form class="c-p-10" v-on:submit.prevent>
              <div class="c-info-title-labels-wrap">
                <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
                <div class="c-info-title"><b>Izmeni informacije za sledeći događaj</b></div>
              </div>
              <!-- Event Date -->
              <div class="c-grid-row">
              <div class="c-form-group c-blue-style" v-bind:class="{'c-has-error' : formVars.eventDate.showError}">
                <label for="event-date" v-if="formVars.eventDate.showError">{{formVars.eventDate.errorMsg}}</label>
                <label for="event-date" v-else>Datum</label>
                  <div class="c-input-group">
                    <datepicker v-model="formVars.eventDate.model" input-class="c-form-control" id="event-date" name="event-date"></datepicker>
                    <div class="c-input-addon-wrap">
                      <button class="c-addon-item"><i class="fa fa-calendar" aria-hidden="true"></i></button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Band name -->
              <div class="c-grid-row">
              <div class="c-form-group c-blue-style" v-bind:class="{'c-has-error' : formVars.eventName.showError}">
                <label for="band-name" v-if="formVars.eventName.showError">{{formVars.eventName.errorMsg}}</label>
                <label for="band-name" v-else>Naziv benda</label>
                  <input type="text" class="c-form-control" id="band-name" name="band-name" 
                  v-model="formVars.eventName.model">
                </div>
              </div>
              <!-- Venue type -->
              <div class="c-grid-row">
              <div class="c-form-group c-blue-style" v-bind:class="{'c-has-error' : formVars.eventVenue.showError}">
                <label for="venue-type" v-if="formVars.eventVenue.showError">{{formVars.eventVenue.errorMsg}}</label>
                <label for="venue-type" v-else>Vrsta rezervacije</label>
                  <select class="c-form-control" id="venue-type" name="venue-type" v-model="formVars.eventVenue.model">
                    <option disabled v-bind:value="null">Izaberite tip rezervacije</option>
                    <option 
                      v-for="(singleVenue, key) in tempListOfAllVenues" 
                      v-bind:value="key"
                      v-if="singleVenue.name"
                    >{{singleVenue.name}}</option>
                  </select>             
                </div>
              </div>
              <!-- Ticket price / Number of sold tickets -->
              <div class="c-grid-row">
                <!-- Ticket price -->
                <div class="c-col-6">
                  <div class="c-form-group c-blue-style">
                    <label for="ticket-price">Cena ulaznice</label>
                    <div class="c-input-group">
                      <input type="text" class="c-form-control" id="ticket-price" name="ticket-price"
                      v-model="formVars.ticketPrice.model">
                      <div class="c-input-addon-wrap">                    
                        <select class="c-addon-item" v-model="formVars.ticketPriceCurrency.model">
                          <option disabled v-bind:value="null">Izaberi</option>
                          <option 
                            v-for="(singleUnitType, key) in tempListOfCurrencyUnits" 
                            v-bind:value="key"
                            v-if="singleUnitType.title"
                          >{{singleUnitType.title}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Band price -->
                <div class="c-col-6">
                    <div class="c-form-group c-blue-style">
                      <label for="ticket-price">Cena benda</label>
                      <div class="c-input-group">
                        <input type="text" class="c-form-control" id="ticket-price" name="ticket-price"
                        v-model="formVars.performerPrice.model">
                        <div class="c-input-addon-wrap">
                          <select class="c-addon-item" v-model="formVars.performerPriceCurrency.model">
                            <option disabled v-bind:value="null">Izaberi</option>
                            <option 
                              v-for="(singleUnitType, key) in tempListOfCurrencyUnits" 
                              v-bind:value="key"
                              v-if="singleUnitType.title"
                            >{{singleUnitType.title}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <!-- eventDate;eventName;eventVenue;ticketPrice;ticketPriceCurrency;
                ticketsSold;performerPrice;performerPriceCurrency;drinkIncome;eventVisibleForAll -->            
              <!-- Band price / Drinks revenue -->
              <div class="c-grid-row">
                <div class="c-col-6">
                  <div class="c-form-group c-blue-style">
                    <label for="tickets-sold">Broj prodatih karata</label>
                    <input type="text" class="c-form-control" id="tickets-sold" name="tickets-sold"
                    v-model="formVars.ticketsSold.model">
                  </div>
                </div>
                <div class="c-col-6">
                  <div class="c-form-group c-blue-style">
                    <label for="drinks-revenue">Prodaja pića</label>
                    <input type="text" class="c-form-control" id="drinks-revenue" name="drinks-revenue"
                    v-model="formVars.drinkIncome.model">
                  </div>
                </div>
              </div>
              <!-- Form divider -->
              <div class="c-form-divider">Dodatne opcije</div>
              <!-- Delete this Event and all connected data (event+reservations-info)  -->
              <div class="c-grid-row">
                <div class="c-form-group c-blue-style">
                  <label for="drinks-revenue">Potpuno obriši ovaj događaj i povezane rezervacije</label>
                  <button class="c-btn c-passive-blue-btn c-col-12" v-on:click="deleteEventCompletely()"><i class="fa fa-trash" aria-hidden="true"></i> <b>Obriši ovaj događaj!</b></button>
                </div>
              </div>
              <!-- Visible for all switch -->
              <!-- <div class="c-grid-row">
                <div class="c-form-group c-blue-style">
                  <label for="visible-for-all">Da li je događaj vidljiv za svo osoblje m:{{formVars.eventVisibleForAll.model}}</label>
                  <div class="c-form-switch">
                    <label class="c-switch-button">
                      <input type="checkbox" v-on:click="formVars.eventVisibleForAll.model = !formVars.eventVisibleForAll.model" v-model="formVars.eventVisibleForAll.model">
                      <div class="c-slider">
                        <div class="c-options-hint-back-wrapper">
                          <div class="c-grid-row"><div class="c-col-6"><b>NE</b></div><div class="c-col-6"><b>DA</b></div></div>
                        </div>
                        <span class="c-slider-btn">
                          <div class="c-align-this">
                            <span class="c-has-vertical-lines c-left"></span>
                            <b v-if="formVars.eventVisibleForAll.model == true" class="c-ux-color-success">DA</b>
                            <b v-else class="c-ux-color-danger">NE</b>
                            <span class="c-has-vertical-lines c-right"></span>
                          </div>
                        </span>
                      </div>
                    </label>
                  </div>
                </div>
              </div> -->
              <!-- Move Event to Archive  -->
              <!-- <div class="c-grid-row">
                <div class="c-form-group c-blue-style">
                  <label for="drinks-revenue">Događaji koji su se završili, mogu da se prebace u arhivu događaja</label>
                  <button class="c-btn c-passive-blue-btn c-col-12" v-on:click="moveEventToArchive()"><i class="fa fa-inbox" aria-hidden="true"></i> <b>Prebaci u arhivu</b></button>
                </div>
              </div> -->
            </form>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import Datepicker from 'vuejs-datepicker';
import OverlayLoader from "@/components/helpers/OverlayLoader";
import moment from 'moment'
import {firebaseDB} from '@/firebase';
export default {
  name: 'ModalArchivedEventDetails',
  props: ['inputModalData'],
  components: {
      Datepicker: Datepicker,
      OverlayLoader: OverlayLoader
  },  
  // firebase: function () {
  //   return {
  //     listOfAllVenues: {
  //       source: firebaseDB.ref('listOfVenues'),
  //       //asObject: true,
  //       // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
  //       //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
  //       // this is called once the data has been retrieved from firebase
  //       readyCallback: function (dataSnapshot) {
  //         //once we have list of all access levels, we can update 'selected option' to be one that user has
  //       }
  //     },
  //     listOfCurrencyUnits: {
  //       source: firebaseDB.ref('listOfCurrencyUnits'),
  //       //asObject: true,
  //       // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
  //       //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
  //       // this is called once the data has been retrieved from firebase
  //       readyCallback: function (dataSnapshot) {
  //         //this.formVars.eventVenue.isLoading.pop();
  //         //once we have list of all access levels, we can update 'selected option' to be one that user has
  //         //this.setSelectedAccessLevelFromUser(dataSnapshot);
  //       }
  //     }
  //   }
  // },  
  data () {
    return {
      msg: 'ModalArchivedEventDetails modal',
      actionStatus: 'event-saved',
      tempListOfAllVenues: {},
      tempListOfCurrencyUnits: {},      
      isLoading: [1],
      formVars: {
        isValid: false,
        eventDate: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Datum je obavezan!'
        },
        eventName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Naziv je obavezan!'
        },
        eventVenue: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Tip rezervacija je obavezan!'
        },
        ticketPrice: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        ticketPriceCurrency: {
          model: null,
          showError: false
        },
        ticketsSold: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },        
        performerPrice: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        performerPriceCurrency: {
          model: null,
          showError: false
        },
        drinkIncome: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        eventVisibleForAll: {
          model: false
        }
      },         
      resolve: null,
      reject: null
    }
  },
  watch: {
    'formVars.eventDate.model' : function (newValue){      
      if (this.formVars.eventDate.showError == true){
        this.formVars.eventDate.showError = false;
      }
    },
    'formVars.eventName.model' : function (newValue){
      if (this.formVars.eventName.showError == true){
        this.formVars.eventName.showError = false;
      }
    },
    'formVars.eventVenue.model' : function (newValue){
      if (this.formVars.eventVenue.showError == true){
        this.formVars.eventVenue.showError = false;
      }
    }
  },  
  methods: {
    // ~ bind data received by selected event
    bindDataFromSelectedEvent: function (inputEventObject) {
      this.formVars.eventDate.model = (inputEventObject.eventDate) ? inputEventObject.eventDate : null;
      this.formVars.eventName.model = (inputEventObject.eventName) ? inputEventObject.eventName : null;
      this.formVars.eventVenue.model = (inputEventObject.eventVenue) ? inputEventObject.eventVenue : null;
      this.formVars.ticketPrice.model = (inputEventObject.ticketPrice) ? inputEventObject.ticketPrice : null;
      this.formVars.ticketPriceCurrency.model = (inputEventObject.ticketPriceCurrency) ? inputEventObject.ticketPriceCurrency : null;
      this.formVars.ticketsSold.model = (inputEventObject.ticketsSold) ? inputEventObject.ticketsSold : null;
      this.formVars.performerPrice.model = (inputEventObject.performerPrice) ? inputEventObject.performerPrice : null;
      this.formVars.performerPriceCurrency.model = (inputEventObject.performerPriceCurrency) ? inputEventObject.performerPriceCurrency : null;
      this.formVars.drinkIncome.model = (inputEventObject.drinkIncome) ? inputEventObject.drinkIncome : null;
      this.formVars.eventVisibleForAll.model = (inputEventObject.eventVisibleForAll) ? inputEventObject.eventVisibleForAll : null;
      ///
      this.isLoading.pop();
    },
    // ~ When we want to save changes created on this modal
    saveChanges: function (){
      var isFormValid = this.returnEventDetailsFormState();
      //firebaseDB.ref().child('/listOfUsers/' + this.formVars.adminUid).update({    
      //console.log('s--save');
      //console.log('selectedEventObject: ' + JSON.stringify(this.inputModalData.dataForModal.selectedEventObject, null, 2) );
      if (isFormValid === true){
        this.isLoading.push(1);
        firebaseDB.ref().child('/listOfArchivedEvents/' + this.inputModalData.dataForModal.selectedEventObject.eventUid).update({
          //Date of event
          eventDate: (this.formVars.eventDate.model) ? moment(this.formVars.eventDate.model).utc().locale('en').toISOString() : null,
          //Event name
          eventName: (this.formVars.eventName.model) ? this.formVars.eventName.model : null,
          //Event Venue type (where event will be placed)
          eventVenue: (this.formVars.eventVenue.model) ? this.formVars.eventVenue.model : null,
          //Event ticket price
          ticketPrice: (this.formVars.ticketPrice.model) ? this.formVars.ticketPrice.model : null,
          //Ticket price currency (RSD, EUR)
          ticketPriceCurrency: (this.formVars.ticketPriceCurrency.model) ? this.formVars.ticketPriceCurrency.model : null,
          //Number of sold tickets
          ticketsSold: (this.formVars.ticketsSold.model) ? this.formVars.ticketsSold.model : null,
          //Performer/Band price
          performerPrice: (this.formVars.performerPrice.model) ? this.formVars.performerPrice.model : null,
          //Performer/Band price currency (RSD, EUR)
          performerPriceCurrency: (this.formVars.performerPriceCurrency.model) ? this.formVars.performerPriceCurrency.model : null,
          //Income from sold drinks
          drinkIncome: (this.formVars.drinkIncome.model) ? this.formVars.drinkIncome.model : null,
          //Is event visible for all (all admins or only high level admin roles)
          eventVisibleForAll: this.formVars.eventVisibleForAll.model
        }).then(
          function (response) {
            //console.log('Firebase Arhived Event Details UPDATE succ: ' + JSON.stringify(response, null, 2));
            var resultToReturn = {
              actionStatus: this.actionStatus
            }
            this.resolve(resultToReturn);
          }.bind(this),
          function (error){
            console.log('Firebase Arhived Event Details UPDATE ERROR: ' + JSON.stringify(error, null, 2));
          }.bind(this)
        );
      }
    },
    returnEventDetailsFormState: function () {
      var returnValue = true;
      //
      if (!this.formVars.eventDate.model){
        returnValue = false;
        this.formVars.eventDate.showError = true;
      }
      if (!this.formVars.eventName.model){
        returnValue = false;
        this.formVars.eventName.showError = true;
      }
      if (!this.formVars.eventVenue.model){
        returnValue = false;
        this.formVars.eventVenue.showError = true;
      }
      return returnValue;
    },
    //Delete event and all related reservations
    deleteEventCompletely: function () {
      this.isLoading.push(1);
      this.actionStatus = 'event-delete-completely';
      this.saveChanges();
    },    
    ///
    // moveEventToArchive: function () {
    //   console.log('move event to archive!');
    //   this.actionStatus = 'event-to-archive';
    //   this.saveChanges();
    // },
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    }
  },
  created () {
    //console.log('~ created- ModalArchivedEventDetails component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      // if (this.inputModalData.selectedEventObject){
      //   //console.log('spec key is: ' + this.inputModalData.selectedEventObject['.key']);
      //   this.bindDataFromSelectedEvent(this.inputModalData.selectedEventObject);
      // }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.selectedEventObject){
        //console.log('selectedEventObject: ' + JSON.stringify(this.inputModalData.dataForModal.selectedEventObject, null, 2) );
        this.bindDataFromSelectedEvent(this.inputModalData.dataForModal.selectedEventObject);
      }      
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.listOfVenueTypes){
        this.tempListOfAllVenues = this.inputModalData.dataForModal.listOfVenueTypes;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.listOfCurrencyUnits){
        this.tempListOfCurrencyUnits = this.inputModalData.dataForModal.listOfCurrencyUnits;
      }
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
    }
  },
  mounted () {
    //console.log('~ mounted - ModalArchivedEventDetails component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalArchivedEventDetails component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/eventsArchive/ModalArchivedEventDetails.vue